import axios from 'axios';
import { filterParams } from '@/utils/m-utils';

import { Loading, Message, MessageBox, Alert } from 'element-ui';
const host = window.location.host.split(":")[0];//获取当前地址
export const _baseUrl = process.env.NODE_ENV !== 'production' ? 'http://192.168.0.181:8881' : 'https://spcbaseinfo.gzybia.com';  //基础信息服务
export const _dataViewUrl = process.env.NODE_ENV !== 'production' ? 'http://192.168.0.181:8911' : 'https://spcdataview.gzybia.com';  //数据大屏
export const _concreteBaseUrl = process.env.NODE_ENV !== 'production' ? 'http://192.168.0.182:8398' : 'https://spcconcrete.gzybia.com';  //混凝土服务
export const _workflowUrl = process.env.NODE_ENV !== 'production' ? 'http://192.168.0.183:8347' : 'https://sworkflow.gzybia.com'; //流程引擎服务
export const _reportFormDesignerServerUrl = process.env.NODE_ENV !== 'production' ? 'http://192.168.0.181:8099' : 'https://sreport.gzybia.com'; //报表设计器服务
export const _reportFormDesignerUrl = process.env.NODE_ENV !== 'production' ? 'http://192.168.0.117:8989/design/index.html' : 'https://report.gzybia.com/design/index.html'; //报表设计器页面
export const _yunzhijiaUrl = process.env.NODE_ENV !== 'production' ? 'http://192.168.0.182:8991' : 'https://sappyzj.gzybia.com'; //云之家

export const _realmName = process.env.NODE_ENV !== 'production' ? host : "gzybia.com";  //生产环境域名 用于设置单点登录 cookie跨域的 domain

export const _qiniuPublicUrl = 'https://qiniu2.gzybia.com';

var config = require('../../../config');
var port = process.env.PORT || config.dev.port;
const _baseLoginUrl = "/login"



export const Request = {};
//请求超时时长
const TIMEOUT = 1000 * 90;
var request = options => {

  //服务端地址
  let _actionUrl = _baseUrl;


  //匹配流程引擎的服务端地址
  if (/workflow/.test(options.action)) {
    _actionUrl = _workflowUrl;
  }
  //匹配数据大屏的服务端地址
  if (/data-visualization/.test(options.action)) {
    _actionUrl = _dataViewUrl;
  }
  //匹配混凝土的服务端地址
  if (/concreteFormula|queryDictTreeByCode|queryTwoLevelDictTreeByCode|concreteLabel|dict\/materialDictionaryTree/.test(options.action)) {
    _actionUrl = _concreteBaseUrl;
  }
  //匹配报表设计器的服务端地址
  if (/report-form-design/.test(options.action)) {
    _actionUrl = _reportFormDesignerServerUrl;
  }
  //云之家
  if (/yzj/.test(options.action)) {
    _actionUrl = _yunzhijiaUrl;
  }



  //开放cookie 本地操作 并且操作后的cookie 携带过去
  axios.defaults.withCredentials = true;
  options.headers = options.headers || {
    'Content-Type': 'application/json;charset=UTF-8',
  };
  //处理查询参数，过滤空值参数
  filterParams(options.params || options.body);

  options.headers = { ...(options.headers || {}) };

  options.body = { ...(options.body || {}) };

  const accessToken = encodeURI(sessionStorage.getItem('accessToken'));
  if (accessToken && !/login/.test(options.action)) {
    options.headers.token = accessToken;
  }
  var loading = null;
  if (options.loading) {
    loading = Loading.service({
      lock: true,
      text: '',
      customClass: 'rc-loading',
      // spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)',
    });
  }
  // const loading = Loading.service({
  //   lock: true,
  //   text: '',
  //   customClass: 'rc-loading',
  //   spinner: 'el-icon-loading',
  //   background: 'rgba(0, 0, 0, 0.7)',
  // });
  return axios
    .request({
      headers: options.headers,
      url: _actionUrl + options.action,
      method: options.method,
      data: options.body,
      params: options.params,
      timeout: TIMEOUT,
      emulateJSON: true,
      responseType: (/excelPerManagementReport-excel/i.test(options.action)) ? "blob" : "json"
      // })
    })
    .then(response => {
      //判断是否导出文件
      if (/excelPerManagementReport-excel/i.test(options.action)) {
        let fileName = options.body.fileName;
        let blob = new Blob([response.data], { type: /deviceBindqrCode/i.test(options.action) ? 'image/jpeg' : 'application/x-xlsx' })
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName);
        } else {
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          link.click();
          window.URL.revokeObjectURL(link.href);
        }
        if (loading)
          loading.close();
        return { msg: "下载成功" };
      }
      //请求结束
      var result = response.data;
      if (result && result.code === '3004') {
        sessionStorage.clear();
        window.location.href = _baseLoginUrl
        result.action = options.action
        throw result;
      }
      if (result && result.code !== '200' && result.code !== '0' && result.code + "" !== '0000') {
        var msg =
          typeof result.msg === 'object'
            ? JSON.stringify(result.msg)
            : result.msg;
        // Message({ message: msg, type: "error" })
        result.action = options.action
        throw result;
      }
      if (loading)
        loading.close();
      return result;
    })
    .catch(e => {
      var msg =
        typeof e.msg === 'undefined'
          ? "连接超时，请稍后再试"
          : e.msg;
      //抛出异常
      Message({ message: msg, type: "error" })
      if (loading)
        loading.close();
      throw e;
    });
};

//http请求方式
const http = {};
['get', 'post', 'put', 'delete'].forEach(method => {
  http[method] = (
    action,
    params,
    extra = {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      },
      loading: true,
      includeToken: false,
    },
  ) => {
    method = method.toUpperCase();
    if (method === 'GET') {
      return request({
        action,
        params,
        method,
        headers: extra.headers,
        loading: extra.loading,
        includeToken: extra.includeToken,
      });
    }
    return request({
      action,
      body: params,
      method,
      headers: extra.headers,
      loading: extra.loading,
      includeToken: extra.includeToken,
    });
  };
});
Request.http = http;


//在main.js设置全局的请求次数，请求的间隙
axios.defaults.retry = 0;
axios.defaults.retryDelay = 1000;

axios.interceptors.response.use(undefined, function axiosRetryInterceptor(err) {
  var config = err.config;
  // If config does not exist or the retry option is not set, reject
  if (!config || !config.retry) return Promise.reject(err);

  // Set the variable for keeping track of the retry count
  config.__retryCount = config.__retryCount || 0;

  // Check if we've maxed out the total number of retries
  if (config.__retryCount >= config.retry) {
    // Reject with the error
    return Promise.reject(err);
  }

  // Increase the retry count
  config.__retryCount += 1;

  // Create new promise to handle exponential backoff
  var backoff = new Promise(function (resolve) {
    setTimeout(function () {
      resolve();
    }, config.retryDelay || 1);
  });

  // Return the promise in which recalls axios to retry the request
  return backoff.then(function () {
    return axios(config);
  });
});



// WEBPACK FOOTER //
// ./src/utils/axios/request.js